import React, { useEffect, useState } from 'react';
import 'react-html5video/dist/styles.css';
import { fetchCorrectAnswerId } from '../../../requests/learning';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { useNavigate } from 'react-router-dom';
import { Answer } from './types';
import {
  Wrapper,
  HeaderText,
  InactivityContainer,
  AnswerExplanation,
  CorrectAnswerSection,
  PictureWrapper,
  ButtonContainer,
  ImgContent,
  ButtonBlock,
} from './Quizzes.styled';
import { Body4, Headline4 } from './../../../app/common/typography';
import { ButtonLarge } from './../../../app/common/sharedComponents/buttons/ButtonLarge';

const QuestionResponse = ({
  question,
  answerSelected,
  setQuizScore,
  onContinueHandler,
  inactivityCounter,
  setInactivityCounter,
  inactivityCounterActive,
  startInactivity = false,
}) => {
  const [isCorrect, setIsCorrect] = useState<boolean | null>(null);
  const navigate = useNavigate();
  const [correctAnswer, setCorrectAnswer] = useState<Answer>();

  useEffect(() => {
    (async () => {
      if (startInactivity) {
        setIsCorrect(false);
        return;
      }
      const { data } = await fetchCorrectAnswerId(question.id);
      setCorrectAnswer(question.answers.find((answer) => answer.id === data));
      const isAnswerChoicedCorrect = String(data) === String(answerSelected.id);
      setIsCorrect(isAnswerChoicedCorrect);
      if (isAnswerChoicedCorrect) {
        setQuizScore((prevState) => Math.round((prevState + 0.1) * 10) / 10);
      }
    })();
  }, [question.id]);

  useEffect(() => {
    if (!inactivityCounterActive) {
      return;
    }
    const countTimeout = setTimeout(
      () => setInactivityCounter(inactivityCounter - 1),
      1000
    );
    const count = inactivityCounter > 0 && countTimeout;
    if (!count) {
      navigate(-1);
    }
    return () => clearTimeout(countTimeout);
  }, [inactivityCounter]);

  if (isCorrect === null || !answerSelected) {
    return <LoadingContent layout="flex" />;
  }

  return (
    <Wrapper>
      <HeaderText isCorrect={isCorrect}>
        {isCorrect ? 'Excellent....correct!' : 'Oops....incorrect.'}
      </HeaderText>
      {startInactivity && (
        <InactivityContainer>
          Inactivity Detected. Closing Quiz in: {inactivityCounter}s
        </InactivityContainer>
      )}
      {!isCorrect && correctAnswer && (
        <CorrectAnswerSection>
          <Body4 color="darkBlue">Correct Answer:</Body4>
          <Headline4 color="darkBlue">{correctAnswer.label}</Headline4>
        </CorrectAnswerSection>
      )}
      <AnswerExplanation>{question.responseMessage}</AnswerExplanation>
      <PictureWrapper>
        <ImgContent src={question.pictureUrl} />
      </PictureWrapper>
      <ButtonContainer>
        <ButtonBlock>
          <ButtonLarge title="Continue" onClick={() => onContinueHandler()} />
        </ButtonBlock>
      </ButtonContainer>
    </Wrapper>
  );
};

export default QuestionResponse;
